export const COMPONENT_NAME = "wallet-cripto-withdrawal";
